import ActionButton from '@/common/components/buttons/ActionButton';
import ListTable from '@/common/components/ListTable';
import Loading from '@/common/components/Loading';
import SuperProductForm from './components/superProductForm/SuperProductForm';
import { SUPER_PRODUCT_COLUMNS, SUPER_PRODUCT_MESSAGES } from './constants/superProduct';
import useSuperProductList from './hooks/useSuperProductList';
import { Wrapper } from './SuperProductList.styled';

const SuperProductList = () => {
	const {
		rows,
		products,
		editingSuperProduct,
		isLoading,
		openCreateForm,
		openEditForm,
		closeForm,
		handleSaved,
	} = useSuperProductList();

	return (
		<>
			{isLoading && <Loading />}
			{rows && (
				<Wrapper>
					<ActionButton
						style={{ width: 'fit-content' }}
						onClick={openCreateForm}
						defaultText={SUPER_PRODUCT_MESSAGES.CREATE_SUPER_PRODUCT}
					/>
					<ListTable
						column={SUPER_PRODUCT_COLUMNS}
						row={rows}
						actions={{ onEdit: openEditForm }}
					/>
				</Wrapper>
			)}
			{editingSuperProduct !== undefined && (
				<SuperProductForm
					superProduct={editingSuperProduct}
					products={products}
					onClose={closeForm}
					onSaved={handleSaved}
				/>
			)}
		</>
	);
};

export default SuperProductList;
